import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { icon } from '@/uiPrimitives/media/icon';
import {
	addTestSelector,
	testSelectorAttribute,
} from '@/globals/testHelpers/testSelector';
import { ReactNode } from 'react';
import {
	scrollButton,
	scrollButtonContainer,
	scrollButtonSticky,
} from './ScrollButton.css';
import { pile } from '@/uiPrimitives/layout/pile';
import {
	pointerEventsAuto,
	pointerEventsNone,
} from '@/uiPrimitives/utility/pointerEvents.css';

const scrollButtonSide = {
	before: {
		adjustIcon: 'flipHorizontal',
	},
	after: {
		adjustIcon: undefined,
	},
} as const;

export const ScrollButton = {
	Shelf: ({
		children,
		className,
		[testSelectorAttribute]: dataUITest,
	}: {
		children: ReactNode;
		className?: string;
		[testSelectorAttribute]?: string;
	}) => {
		return (
			<span
				className={classes(className, scrollButtonContainer)}
				{...addTestSelector(dataUITest)}
			>
				{children}
			</span>
		);
	},

	Item: ({
		isShowing,
		buttonLabel,
		onClick,
		side,
		className,
	}: {
		side: 'before' | 'after';
		isShowing: boolean;
		buttonLabel: string;
		onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
		className?: string;
	}) => {
		return (
			<span className={classes(scrollButtonSticky)}>
				<button
					type="button"
					aria-disabled={!isShowing}
					onClick={isShowing ? onClick : undefined}
					tabIndex={isShowing ? 0 : -1}
					className={classes(
						className,
						scrollButton[side],
						isShowing ? pointerEventsAuto : pointerEventsNone,
						box({
							size: '4 | betweenListItems',
							backgroundColor: 'positiveBlue',
							opacity: isShowing ? '1' : '0',
							opacityTransition: 'fast',
						}),
						pile({
							alignItems: 'center',
							justifyItems: 'center',
						}),
					)}
				>
					<i
						role="img"
						aria-label={buttonLabel}
						className={classes(
							icon({
								icon: chevronIcon,
								adjustIcon: scrollButtonSide[side].adjustIcon,
								inlineSize: 'auto',
								blockSize: '-1 | small',
							}),
						)}
					/>
				</button>
			</span>
		);
	},
};
